(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/header.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/header.js');
"use strict";


const Header = () => React.createElement("div", {
  className: "f-body"
}, React.createElement("h1", {
  className: "tg-gift-header u-text-center h1"
}, "V\xE4lj lotter att ge bort"));
svs.tickets_giftshop.gift.components.Header = Header;

 })(window);